var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.948305 0H17.0513C17.5733 0 18.0003 0.427 18.0003 0.949V1.051C18.0003 1.573 17.5733 2 17.0513 2H0.948305C0.426305 2 0.000305176 1.573 0.000305176 1.051V0.949C0.000305176 0.427 0.426305 0 0.948305 0ZM17.0513 5H0.948305C0.426305 5 0.000305176 5.427 0.000305176 5.949V6.051C0.000305176 6.573 0.426305 7 0.948305 7H17.0513C17.5733 7 18.0003 6.573 18.0003 6.051V5.949C18.0003 5.427 17.5733 5 17.0513 5ZM17.0513 10H0.948305C0.426305 10 0.000305176 10.427 0.000305176 10.949V11.051C0.000305176 11.573 0.426305 12 0.948305 12H17.0513C17.5733 12 18.0003 11.573 18.0003 11.051V10.949C18.0003 10.427 17.5733 10 17.0513 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.99015569ff866c9e0dca72da2be8377e.svg";
export { ForwardRef as ReactComponent };